import React from 'react'
import { useNavContext } from '../useNavContext'
import MobileChildMenu from './MobileChildMenu'
import ShowcaseEntry from '@toasttab/shared/src/components/organisms/Navigation/Contentful/ShowcaseEntry'
import SubMenuEntry from '@toasttab/shared/src/components/organisms/Navigation/Contentful/SubMenuEntry'
import Button from '@toasttab/shared/src/components/atoms/Button/Button'
import _helpers from '@toasttab/shared/src/globals/_helpers'
import { MobileSubMenuProps } from '@toasttab/shared/src/components/organisms/Navigation/Contentful/ContentfulNavigation.d'
import NavHighlightSection from '../NavHighlightSection'

const MobileSubMenu = ({
  ctaLabel,
  ctaLink,
  description,
  handleCloseButton,
  heading,
  highlightSection,
  showcaseEntries,
  subMenus,
  title
}: MobileSubMenuProps) => {
  const { selectedParentMenu, setSelectedParentMenu } = useNavContext()

  const handleBackButton = () => {
    setSelectedParentMenu(null)
  }
  const sortedSubMenus = subMenus?.columns?.flat()
  if (sortedSubMenus?.some((sub) => sub.mobileOrder)) {
    sortedSubMenus.sort((a, b) => a.mobileOrder - b.mobileOrder)
  }

  return (
    <MobileChildMenu
      ariaLabel={`Toast ${title} Dropdown Menu`}
      handleBackButton={handleBackButton}
      handleCloseButton={handleCloseButton}
      id={`${title.replace(/\s/g, '-')}-mobile-menu`}
      isOpen={selectedParentMenu === title}
      showFooterMenu
      title={title}
    >
      {heading ? (
        <div className='border-b border-light pb-4 mb-4'>
          <h3 className='heading-3'>{heading}</h3>
          {description ? (
            <p className='text-secondary mt-1'>{description}</p>
          ) : null}
          {ctaLabel && ctaLink ? (
            <Button
              classes='!w-auto mt-4'
              href={ctaLink}
              size='medium'
              variation='secondary'
            >
              {ctaLabel}
            </Button>
          ) : null}
        </div>
      ) : null}
      {highlightSection ? (
        <NavHighlightSection {...highlightSection} classes='mb-6' />
      ) : null}
      {!(heading || highlightSection) && showcaseEntries?.length ? (
        // Display Showcase at the top unless we have the heading block or highlight content
        <div className='mb-6'>
          {showcaseEntries.map((showcase: any) => (
            <ShowcaseEntry
              key={`${title}-${showcase.title}`}
              menuType='mobile'
              {...showcase}
            />
          ))}
        </div>
      ) : null}
      {sortedSubMenus?.map((submenu: any) => (
        <SubMenuEntry
          key={`${title}-${submenu?.title}`}
          menuType='mobile'
          {...submenu}
        />
      ))}
      {(heading || highlightSection) && showcaseEntries?.length ? (
        // Display Showcase at the bottom if we have the heading block or highlight content
        <div className='-mb-4'>
          {showcaseEntries.map((showcase: any) => (
            <ShowcaseEntry
              key={`${title}-${showcase.title}`}
              menuType='mobile'
              {...showcase}
            />
          ))}
        </div>
      ) : null}
    </MobileChildMenu>
  )
}

export default MobileSubMenu
